import React from 'react'
import { PillarPage } from 'src/constants/searchPages'
import FAQSection from './FAQSection'
import Hero from './Hero'
import HostBand from './HostBand'
import Logos from './Logos'
import RecommendedSection from './RecommendedSection'
import StepsSection from './StepsSection'
import VerticalsSection from './VerticalsSection'

/**
 * Conversion-ordered home funnel.
 *
 *  1. Hero               — editorial dark hero: H1 with city accent + city-
 *                          aware primary CTA (storage × user-city) + parking
 *                          secondary + pillar chip row + faded search
 *                          fallback + supply microlink + last-search resume.
 *  2. RecommendedSection — inventory proof. Eager (queries once the IP
 *                          center resolves, no scroll gate) and storage-first
 *                          with a parking toggle, so the second beat shows
 *                          the product the hero just sold.
 *  3. VerticalsSection   — one row of five tiles: every other space type in
 *                          a single viewport, storage tile featured.
 *  4. Logos              — partner trust badge
 *  5. StepsSection       — how it works (stacked on mobile)
 *  6. HostBand           — slim host ask (one line + "Sube tu espacio"),
 *                          the first host-facing block after the hero.
 *  7. FAQSection         — long-tail SEO FAQ
 *
 * The Reviews testimonial band was removed 2026-09-30: its quotes and the
 * rating/review counts were invented — there are no real reviews yet.
 *
 * Restructured 2026-09-06 on a below-the-fold read (MX, 7 weeks, 935
 * sessions): on mobile 85% of leavers never passed 25% of a 12.5-viewport
 * page, the five-row verticals section was 38% of that height for 8 clicks,
 * the stats block repeated every hero number within two viewports, and the
 * logistics callout drew 0 clicks. Removed: SocialProofStats (since deleted —
 * its rating/review numbers were invented), LogisticsCallout (deleted — the 3PL link lives in
 * the nav + footer). The full host-recruitment CTASection went earlier so it
 * would not pull renters out of the funnel; HostBand (2026-09-06) restores a
 * slim version low on the page because ~1 in 18 home sessions is a host and
 * the footer card alone drew ONE click from `/` in 30 days (it sits below
 * the FAQ + footer columns). See HostBand.tsx for the numbers.
 */
function LandingPage() {
  return (
    <>
      <Hero />
      <RecommendedSection
        surface="home_recommended"
        pillarToggle={[PillarPage.SelfStorage, PillarPage.Parking]}
        eagerLoad
      />
      <VerticalsSection />
      <Logos
        band="demand"
        className="border-y border-ink-100/15 bg-white-500 py-4"
      />
      <StepsSection />
      <HostBand />
      <FAQSection />
    </>
  )
}

export default React.memo(LandingPage)
